import { getRuntimeConfig } from 'helpers/runtimeConfig';

const Auth = () => {
  const ALLOWED_AUTH_TYPES = ['USER_SRP_AUTH', 'USER_PASSWORD_AUTH'];
  const CONFIG_AUTH_TYPE = getRuntimeConfig().env.REACT_APP_COGNITO_AUTH_TYPE;
  const AUTH_TYPE = ALLOWED_AUTH_TYPES.includes(CONFIG_AUTH_TYPE) ? CONFIG_AUTH_TYPE : 'USER_SRP_AUTH';

  return {
    Auth: {
      authenticationFlowType: AUTH_TYPE,
      mandatorySignIn: false,
      cookieStorage: {
        domain: getRuntimeConfig().env.REACT_APP_COGNITO_COOKIE_DOMAIN,
        path: '/',
        expires: 365,
        secure: true,
      },
    },
  };
};

export default Auth;
